<template>
  <div
    v-if="tickets.variants"
    class="type-tickets-select-without-hall--select-block"
  >
    <div class="type-tickets-select-without-hall--select-list">
      <div
        :key="`${variant.name}-${index}`"
        v-for="(variant, index) in tickets.variants"
        class="type-tickets-select-without-hall--select-list-item"
      >
        <div
          class="type-tickets-select-without-hall--select-list-item-select-name-variant"
        >
          <p>{{ variant.Name }}</p>
        </div>

        <div class="type-tickets-select-without-hall--select-list-item-info">
          <p v-if="variant.Sum">{{ variant.Sum }} {{ setting.currency }}</p>
          <p v-else>Бесплатно</p>
        </div>

        <div class="type-tickets-select-without-hall--select-list-item-select">
          <div
            class="type-tickets-select-without-hall--select-list-item-select-minus"
            @click="() => decreaseTicketTypeHandler(tickets, variant)"
          ></div>
          <div
            class="type-tickets-select-without-hall--select-list-item-select-count"
          >
            <p>
              {{
                cart.tickets.filter(({ Name }) => Name === variant.Name).length
              }}
            </p>
          </div>
          <div
            class="type-tickets-select-without-hall--select-list-item-select-plus"
            @click="() => increaseTicketTypeHandler(tickets, variant)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';

export default {
  name: 'selectPlaceWithoutHall',

  computed: {
    ...mapState(['session', 'cart', 'errors', 'places', 'setting', 'theatre']),

    tickets() {
      if (!!this.session.Prices && this.session.Prices.length) {
        const sessionPriceList = this.session.Prices.map((item) => ({
          ticketId: item.TicketId,
          name: item.Name,
          id: item.Id,
          variants: [
            ...item.Discounts,
            { TicketId: item.TicketId, Name: item.TicketName, Sum: item.Sum },
          ],
        }))[0];

        return {
          ...sessionPriceList,
          variants: sessionPriceList.variants.sort(
            (a, b) => a.TicketId - b.TicketId,
          ),
        };
      }
    },
  },

  methods: {
    log: (m) => console.log(m),
    decreaseTicketTypeHandler: function (tickets, variant) {
      const index = this.cart.tickets.findIndex(
        ({ Name }) => Name === variant.Name,
      );

      this.$store.dispatch('logTicket', {
        place: {
          name: this.cart.tickets[index].name,
          id: this.cart.tickets[index].id,
          Name: variant.Name,
          number: this.cart.tickets[index].number,
          price: variant.Sum,
          row: this.cart.tickets[index].row,
          typeId: variant.TicketId,
          variants: [
            {
              Name: variant.Name,
              Sum: variant.Sum,
              typeId: variant.TicketId,
            },
          ],
        },
        type: 'RemoveItem',
        index,
      });
    },
    increaseTicketTypeHandler: function (tickets, variant) {
      let currentCartTicketCount = this.cart.tickets.length;
      let maxSeats = this.theatre.MaxSeats ? this.theatre.MaxSeats : 10;

      const freePlaces = this.places.filter(
        ({ Status, FragmentId, ticketId, Number, Row, Id }) => {
          const isPlaceInCart = this.cart.tickets.find(
            (item) => item.id === Id,
          );
          const isPlaceInRemovedList = this.cart.deletedTickets.find(
            (item) => item.id === Id,
          );

          return (
            (Status === 'Free' || !!isPlaceInCart || !!isPlaceInRemovedList) &&
            !FragmentId &&
            ticketId === tickets.TypeId &&
            this.cart.tickets.every(
              (ticketInBucket) =>
                ticketInBucket.row != Row || ticketInBucket.number != Number,
            )
          );
        },
      );

      if (currentCartTicketCount === maxSeats) {
        this.$store.commit(
          types.ADD_ERROR,
          `Максимальное возможное количество мест для выбора не должно превышать ${maxSeats}шт.`,
        );
        this.$store.commit(types.CLEAR_ERRORS, 3000);

        return;
      }

      console.log(tickets, variant, freePlaces, 'true');
      console.log(this.places, 'places');

      console.log(
        this.places.filter(
          ({ FragmentId, ticketId, Number, Row }) =>
            !FragmentId &&
            ticketId === tickets.TypeId &&
            this.cart.tickets.every(
              (ticketInBucket) =>
                ticketInBucket.row != Row || ticketInBucket.number != Number,
            ),
        ),
        'places1',
      );

      this.$store.dispatch('logTicket', {
        place: {
          name: tickets.name,
          id: freePlaces[0].Id,
          Name: variant.Name,
          number: freePlaces[0].Number,
          price: variant.Sum,
          row: freePlaces[0].Row,
          typeId: variant.TicketId,
          variants: [
            {
              Name: variant.Name,
              Sum: variant.Sum,
              typeId: variant.TicketId,
            },
          ],
        },
        type: 'AddItem',
      });
    },
  },
};
</script>

<style src="./SelectPlaceWithoutHall.scss" lang="scss"></style>
